<template>
    <div class="card mb-4">
        <div class="card-header">
            <h1 class="card-title">
                <span class="align-middle">{{ $t('cars.search.results.panelTitle') }}</span>
                <span class="ml-2 badge badge-secondary align-middle">
                    {{ packages.length }}
                    <template v-if="packages.length < totalPackages">
                        {{ $t('cars.search.results.of') }} {{ totalPackages }}
                    </template>
                </span>
            </h1>
        </div>
        <div id="car-packages" class="list-group list-group-flush">
            <car-package v-for="carPackage in packages"
                         :key="carPackage.packageId"
                         :car-package="carPackage"
                         @quote="(carPackage) => { $emit('quote', carPackage) }">
            </car-package>
        </div>
    </div>
</template>

<script>
    import carPackage from './Package';

    export default {
        props: ['packages', 'totalPackages'],
        components: {
            carPackage: carPackage
        },
    };
</script>

<style scoped>

</style>